import Config from "../../core/core/calcule/Config";
import MindElementCalculation from "../../core/core/calcule/elementCalculation/MindElementCalculation";
import MindDateFormat from "../../core/core/dataformat/MindDateFormat";
import Strings from "../../utils/Strings";
import IdGenerator from "../../viewmodel/core/base/IdGenerator";
import SettingData from "../../viewmodel/core/minddata/SettingData";
import DeviceType from "../../viewmodel/datatype/DeviceType";
import LineLayout from "../../viewmodel/datatype/LineLayout";
import MindBGStripesType from "../../viewmodel/datatype/MindBGStripesType";
import MindDisplayType from "../../viewmodel/datatype/MindDisplayType";
import MindElementType from "../../viewmodel/datatype/MindElementType";
import MindType from "../../viewmodel/datatype/MindType";
import NodeLayoutType from "../../viewmodel/datatype/NodeLayoutType";
import LineMindTypeNode from "../../viewmodel/mindelementdata/LineMindTypeNode";
import MindElementData from "../../viewmodel/mindelementdata/MindElementData";
import MindmapSDKSubjectData from "./MindmapSDKSubjectData";
import MindmapSDKSubjectNode from "./MindmapSDKSubjectNode";
import MindmapSDKTextStyleCell from "./MindmapSDKTextStyleCell";

class SDKDatas {

    constructor() {
        this.ApiKey = "uOAH_9zcuTBDc5UwtWg6E5PjHIfi51wBZihHANiducc="
        this.rootNode = null; //主体树状数据结构
        this.lineColors = new Array(); //主体线颜色:[0xff3300, 0x222222,...] 第一个为中心主体背景色
        this.styleIndex = 3;
        this.frameworkIndex = 5; //如何每个主题单独配色和形状，骨架设置为-1
        this.lineWidth = 2.0;//范围1～4
        this.lineLayout = LineLayout.CURVE_LINE_2; //线条样式
        this.layout = NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE; //整体布局
        this.mindType = MindType.LINE_MAP; //默认为思维导图
        this.mindBGColor = 0xffffff; //背景颜色
        this.deviceType = DeviceType.WEB;
        this.showSaveImageButton = true;
        this.showFullscreenButton = true;
        this.aiText = ""; //AI转思维导图内容；最大长度支持4000个字符
        this.chatPrompt = ""; //AI转思维导图提示词；可以是空
        this.zoomScale = 0; //0 表示自适应，0.0~3.0 范围，1表示不缩放
    }

    setDatas(rootNode,
        lineColors,
        lineWidth,
        lineLayout,
        freeNodes,
        encircle,
        explainData) {
        this.rootNode = rootNode;
        this.lineColors = lineColors;
        this.lineWidth = lineWidth;
        this.lineLayout = lineLayout;
        this.layout = layout;
        this.mindType = mindType;
        this.mindBGColor = mindBGColor;

        return this;
    }

    toJSONString() {
        this.deviceType = DeviceType.WEB;
        let that = this
        let nodeStr = JSON.stringify(this, function (key, val) {
            if (typeof val === "function") {
                return val + '';
            }
            return that.formatNumber(val)
        });
        return nodeStr;
    }

    getTestData() {
        let sdkData = new SDKDatas()
        let rootData = new MindmapSDKSubjectData()
        rootData.text = "中国心"
        rootData.textColor = 0x000000
        let rootNode = new MindmapSDKSubjectNode(rootData)

        let subData = new MindmapSDKSubjectData()
        subData.text = "爱国"
        subData.textColor = 0x222222
        let subNode = new MindmapSDKSubjectNode(subData)
        rootNode.children.push(subNode)        
        if (Math.random() > 0.5) {
            this.pushSDKData(subNode.children, "敬重历史")
            this.pushSDKData(subNode.children, "传承民族文化")
        }

        subData = new MindmapSDKSubjectData()
        subData.text = "爱民族"
        subData.textColor = 0x222222
        subNode = new MindmapSDKSubjectNode(subData)
        rootNode.children.push(subNode)        
        if (Math.random() > 0.5) {
            this.pushSDKData(subNode.children, "热爱祖国山河")
            this.pushSDKData(subNode.children, "心系家乡发展")
        }

        subData = new MindmapSDKSubjectData()
        subData.text = "爱故土家乡"
        subData.textColor = 0x222222
        subNode = new MindmapSDKSubjectNode(subData)
        rootNode.children.push(subNode)
        if (Math.random() > 0.5) {
            this.pushSDKData(subNode.children, "热爱祖国山河")
            this.pushSDKData(subNode.children, "心系家乡发展")
        }
        subData = new MindmapSDKSubjectData()
        subData.text = "崇德向善"
        subData.textColor = 0x222222
        subNode = new MindmapSDKSubjectNode(subData)
        rootNode.children.push(subNode)
        if (Math.random() > 0.5) {
            this.pushSDKData(subNode.children, "热爱祖国山河")
            this.pushSDKData(subNode.children, "心系家乡发展")
        }

        sdkData.rootNode = rootNode

        return sdkData.toJSONString()
    }

    pushSDKData(list, text) {
        let subData = new MindmapSDKSubjectData()
        subData.text = text
        subData.textColor = 0x222222
        subData.textFontSize = 14
        let subNode = new MindmapSDKSubjectNode(subData)

        list.push(subNode)
        return subNode
    }

    format(vaule) {
        let mind = JSON.parse(vaule)
        let mindDate = this.deserializationData(mind)        
        return mindDate;
    }

    generateNodeId(preId) {
        if (preId <= -1) {
            IdGenerator.shared.setId(0);
            return 0;
        }
        return IdGenerator.shared.getId();
    }

    sdkNodeToMindNode(sdkNode, preId) {
        let node = new LineMindTypeNode();
        if (sdkNode == null || sdkNode.value == null) {
            return node
        }              
        
        node.value = sdkNode.value.toMindElementData();
        node.value.id = this.generateNodeId(preId);
        if (node.value.id == 0) {
            node.value.type = MindElementType.MAIN_SUBJECT
            node.value.level = 0
            node.value.textContent.textBold = true;
            MindElementCalculation.set(node.value).caluleTextForData().calcule();
        } else {
            node.value.type = MindElementType.SON_SUBJECT
            node.value.textContent.textBold = false;
            MindElementCalculation.set(node.value).caluleTextForData().calcule();
        }
        let children = new Array();
        var id = node.value.id
        for (let index = 0; index < sdkNode.children.length; index++) {
            const item = sdkNode.children[index];
            const childNode = this.sdkNodeToMindNode(item, id)
            childNode.value.parentNodeId = node.value.id
            if (node.value.id == 0) {
                childNode.value.type = MindElementType.SUBJECT
                childNode.value.textContent.textBold = true;
                MindElementCalculation.set(childNode.value).caluleTextForData().calcule();
            }
            if (node.value.level > -1) {
                childNode.value.level = node.value.level + 1
            }
            if (childNode.isEmpty()) {
                continue;
            }

            id = childNode.value.id
            children.push(childNode)
        }
        node.children = children;
        
        return node
    }

    getMindContent() {
        IdGenerator.shared.resetId()
        let mindDateFormat = new MindDateFormat();
        mindDateFormat.mindType = MindType.LINE_MAP;
        mindDateFormat.mindBGColor = this.mindBGColor;
        mindDateFormat.mindDisplayType = MindDisplayType.MindMap;
        mindDateFormat.styleIndex = 3;
        mindDateFormat.version = Config.MindFormatVersion;
        mindDateFormat.mindGlobalAudio = "";
        mindDateFormat.mindBGStripesType = MindBGStripesType.NonExistent;
        mindDateFormat.settingData = new SettingData();
        mindDateFormat.rootNode = this.sdkNodeToMindNode(this.rootNode, -1)
        
        mindDateFormat = mindDateFormat.setDatas(
            mindDateFormat.rootNode,
            new Array(),
            new Array(),
            new Array(),
            new Array(),
            new Array(),
            new Array())
            .setLayout(this.layout, this.lineLayout);
        return mindDateFormat.toJSONString()
    }

    deserializationData(mind) {
        let data = new SDKDatas();
        for (var key in mind) {
            let keyValue = mind[key]
            data[key] = keyValue
            if (key == "rootNode") {
                let rootNode = this.deserializeNode(keyValue)
                data[key] = rootNode
            } else if (key == "lineColors") {
                var lineColors = []
                if (keyValue != null && keyValue.length > 0) {                    
                    for (let index = 0; index < keyValue.length; index++) {
                        if (keyValue[index] <= 1) {
                            lineColors.push(0x000002)
                        } else {
                            lineColors.push(keyValue[index])
                        }
                    }                    
                }
                data[key] = lineColors
            } else if (key == "zoomScale") {
                if (typeof keyValue === "number") {
                    data[key] = keyValue
                } else {
                    data[key] = -1
                }                
            } 
        }
        return data
    }


    deserializeNode(nodeValue) {
        let node = new MindmapSDKSubjectNode()
        for (var nodeKey in nodeValue) {
            let nodeKeyValue = nodeValue[nodeKey]
            node[nodeKey] = nodeKeyValue
            if (nodeKey == "value") {
                node[nodeKey] = this.deserializeData(nodeKeyValue);
            } else if (nodeKey == "children") {
                let children = new Array();
                let childSize = nodeKeyValue.length
                for (let index = 0; index < childSize; index++) {
                    children.push(this.deserializeNode(nodeKeyValue[index]))
                }
                node[nodeKey] = children
            }
        }
        return node
    }

    deserializeData(dataValue) {
        if (dataValue == null) {
            return new MindmapSDKSubjectData();
        }
        let mindElementData = new MindmapSDKSubjectData()
        for (var mindElementDataKey in dataValue) {
            let mindElementDataValue = dataValue[mindElementDataKey]
            mindElementData[mindElementDataKey] = mindElementDataValue
            if (mindElementDataKey == "styleCells") {
                let styleCells = []
                for (let index = 0; index < mindElementDataValue.length; index++) {
                    let cell = mindElementDataValue[index]
                    let styleCell = new MindmapSDKTextStyleCell()
                    for (var cellKey in cell) {
                        let cellValue = cell[cellKey]
                        styleCell[cellKey] = cellValue
                    }
                    styleCells.push(styleCell)
                }
                mindElementData[mindElementDataKey] = styleCells;
            }
        }
        return mindElementData
    }

    formatNumber(value) {
        if (typeof value === "number") {
            let newValue = Math.round(value*100)/100;
            if (newValue == value) {
                return value
            } else {
                return newValue
            }
        } else {
            return value
        }
    }
}
export default SDKDatas
